// Since the majority of our urls will come from a CMS, and our
// pages/routes are dynamic there's no way to tell what should
// be a page/route link VS external link.
// The following function makes the assumption that all our routes will match
// one of the following urls: "/" "/home" "/my-page" "/my-nested/page" "/blog-post/1"

const isLinkRegex = /^\/(\s|[a-zA-Z\d-/]*)$/;

export function isUrlInternal(url: string = ''): boolean {
  // Handle hash param
  // if (url.includes('#')) {
  //   const splitUrl = url.split('#');

  //   return !!splitUrl[0].match(isLinkRegex);
  // }

  return !!url.match(isLinkRegex);
}
